(() => {
  const BOOST_SELECTOR = '.boost-button[data-variant-id][data-product-id]';
  const LAST_PICK_KEY = 'dig_last_booster_variant';

  if (window.__digCartMultipliersLoaded) return;
  window.__digCartMultipliersLoaded = true;

  const root = window.Shopify?.routes?.root || '/';
  const route = (path) => `${root.replace(/\/$/, '')}${path}`;

  const fetchJson = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      ...options
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`${url} failed: ${response.status} ${text}`);
    }

    return response.json();
  };

  const getButtons = () => Array.from(document.querySelectorAll(BOOST_SELECTOR));

  const getBoosters = () =>
    getButtons()
      .map((button) => ({
        button,
        variantId: Number(button.dataset.variantId),
        productId: Number(button.dataset.productId),
        multiplier: Number(button.dataset.multiplier || 1)
      }))
      .filter((booster) => booster.variantId > 0 && booster.productId > 0);

  const setActiveUI = (variantId) => {
    getBoosters().forEach(({ button, variantId: id }) => {
      const active = Number(id) === Number(variantId);
      button.classList.toggle('selected', active);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const setBusy = (busy) => {
    getButtons().forEach((button) => {
      button.disabled = busy || button.dataset.soldOut === 'true';
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
  };

  const fetchCart = () => fetchJson(route('/cart.js'));

  const removeLineItem = (lineKey) =>
    fetchJson(route('/cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    });

  const addVariant = (variantId) =>
    fetchJson(route('/cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

  const removeExistingBoosters = async () => {
    const boosters = getBoosters();
    const boosterVariantIds = boosters.map((booster) => booster.variantId);
    const boosterProductIds = boosters.map((booster) => booster.productId);
    const cart = await fetchCart();

    const multiplierItems = (cart.items || []).filter((item) => {
      return (
        boosterVariantIds.includes(Number(item.variant_id)) ||
        boosterProductIds.includes(Number(item.product_id))
      );
    });

    for (const item of multiplierItems) {
      await removeLineItem(item.key);
    }
  };

  const syncActiveFromCart = async () => {
    const boosters = getBoosters();
    if (!boosters.length) return;

    const cart = await fetchCart();
    const cartItems = cart.items || [];
    const boosterProductIds = boosters.map((booster) => booster.productId);

    const multiplierItems = cartItems.filter((item) =>
      boosterProductIds.includes(Number(item.product_id))
    );

    if (!multiplierItems.length) {
      setActiveUI(null);
      return;
    }

    const lastPick = Number(sessionStorage.getItem(LAST_PICK_KEY) || 0);
    const lastPickInCart = multiplierItems.some((item) => Number(item.variant_id) === lastPick);

    if (lastPickInCart) {
      setActiveUI(lastPick);
      return;
    }

    const strongest = multiplierItems
      .map((item) => {
        const booster = boosters.find((entry) => entry.productId === Number(item.product_id));
        return {
          variantId: Number(item.variant_id),
          multiplier: booster?.multiplier || 1
        };
      })
      .sort((a, b) => b.multiplier - a.multiplier)[0];

    setActiveUI(strongest?.variantId || null);
  };

  const onBoostClick = async (event) => {
    const button = event.target.closest(BOOST_SELECTOR);
    if (!button) return;

    event.preventDefault();

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const isSelected =
      button.classList.contains('selected') ||
      button.classList.contains('is-active') ||
      button.getAttribute('aria-pressed') === 'true';

    setBusy(true);

    try {
      await removeExistingBoosters();

      if (isSelected) {
        sessionStorage.removeItem(LAST_PICK_KEY);
      } else {
        sessionStorage.setItem(LAST_PICK_KEY, String(variantId));
        await addVariant(variantId);
      }

      window.location.reload();
    } catch (error) {
      console.error('[cart-multipliers]', error);
      window.alert('Could not update multiplier. Please try again.');
      setBusy(false);
    }
  };

  document.addEventListener('click', onBoostClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncActiveFromCart, { once: true });
  } else {
    syncActiveFromCart();
  }

  document.addEventListener('shopify:section:load', syncActiveFromCart);
})();
